<template>
  <view class="dialog-prompt-demo">
    <cube-button  bind:click="onClickDialog">Dialog - prompt</cube-button>
    <cube-dialog

      wx:ref="dialogPrompt"
      type="prompt"
      prompt="{{ promptData }}"
      title="我是标题"
      cancel-btn="取消"
      confirm-btn="确认"
    ></cube-dialog>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  data: {
    promptData: {
      placeholder: '请输入'
    }
  },
  methods: {
    onClickDialog () {
      const dialogRef = this.$refs.dialogPrompt
      dialogRef.show()
    }
  }
})
</script>

<style lang="stylus">
.dialog-btn-content
  text-align center
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-dialog": "@mpxjs/mpx-cube-ui/src/components/dialog/index"
    }
  }
</script>
